import React from 'react';
import { IconProps } from '.';

const SvgMegaphone = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M2.5 16V8l16-6v5.355a4.752 4.752 0 0 1 0 9.29V22L7.266 17.787l1.439 3.957-1.41.512-1.877-5.162L2.5 16Zm5.25.367L4 14.96V9.04l3.75-1.407v8.734Zm1.5.562L17 19.836V4.165L9.25 7.07v9.858ZM20.75 12a3.252 3.252 0 0 1-2.25 3.093V8.907A3.251 3.251 0 0 1 20.75 12Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgMegaphone;
